import { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Pencil, Loader2 } from "lucide-react";

export const EmailDialog = ({ admin, onSaved }) => {
  const { user, setUser } = useAuth();
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState(admin.email);
  const [saving, setSaving] = useState(false);

  const save = async () => {
    const next = email.trim().toLowerCase();
    if (!next || next === admin.email) return setOpen(false);
    setSaving(true);
    try {
      await api.put(`/admins/${admin.id}/email`, { email: next });
      toast.success(`Adresse modifiée : ${next} — un mail de confirmation a été envoyé`);
      if (user?.id === admin.id) setUser({ ...user, email: next });
      onSaved(admin.id, next);
      setOpen(false);
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Échec de la modification");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { setOpen(o); if (o) setEmail(admin.email); }}>
      <DialogTrigger asChild>
        <Button size="icon" variant="ghost" title="Modifier l'adresse mail" data-testid={`change-email-${admin.id}`}>
          <Pencil className="h-4 w-4" />
        </Button>
      </DialogTrigger>
      <DialogContent data-testid="email-dialog">
        <DialogHeader>
          <DialogTitle>Modifier l'adresse mail</DialogTitle>
          <DialogDescription>Cette adresse sert d'identifiant de connexion. Le mot de passe ne change pas.</DialogDescription>
        </DialogHeader>
        <div className="space-y-1.5">
          <Label className="text-xs">Nouvelle adresse</Label>
          <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} onKeyDown={(e) => e.key === "Enter" && save()} data-testid="new-email-input" />
        </div>
        <DialogFooter>
          <Button onClick={save} disabled={saving} data-testid="save-email-button">
            {saving && <Loader2 className="mr-1 h-4 w-4 animate-spin" />} Enregistrer
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
